import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Img01 from '../images/balloonsodyssey/images-03.png';


export default function BalloonsOdyssey_Skin02() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: Beta skin"
        description="Beta skin is obtainable during beta test of Balloons Odyssey."
        images={[BalloonsOdyssey_Img01]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}